const user = {
	banner: [{
			tips:'账户信息',
			title:'账户信息',
			content:'',
			img: require('@/assets/img/index/GPI_2x.png'),
			url: require('@/assets/img/index/banner01.png'),
		}],
		leftNav:[
			{id: '1', name:'个人中心', icon:'',},
			{id: '2', name:'我的任务', icon:'',},
			{id: '3', name:'我的报告', icon:'',},
			{id: '4', name:'消息通知', icon:'',},
		],
		userInfo:{
			title:"个人信息",
			account:'登录账号',
			companyName:'用户名',
			status:'状态',
			icon: require('@/assets/img/service/3.png'),
			password:"修改密码",
			logOut:"账号注销"
		},
		companyInfo:{
			tips:'企业认证',
			title:"企业信息",
			account:'邮箱',
			companyName:'公司名称',
			status:'认证状态',
			icon: require('@/assets/img/service/2.png')
		},
		apply:{
			title:'我的申请',
			icon: require('@/assets/img/index/EPD_2x.png'),
			EPD:'EPD',
			detection:"CFP",
			verify:"LCA"
		},	
		report:{
			title:'我的报告',
			icon: require('@/assets/img/index/LCA_2x.png'),
			EPD:'EPD',
			detection:"CFP",
			verify:"LCA"
		},
		password:{
			label:{
				oldPassword:'旧密码',
				newPassword:'新密码',
				confirmPassword:'确认密码',
				save:'提	交',
				close:"取 消"
			},
			placeholder:{
				oldPassword:'请输入旧密码',
				newPassword:'请输入新密码',
				confirmPassword:"请确认新密码"	
			},
			rules:{
				oldPassword:	[{ required: true, message:'请输入旧密码', trigger: 'blur' },],
				newPassword:	[{ required: true, message:'请输入新密码', trigger: 'blur' },],	
				confirmPassword:	[{ required: true, message:'请确认新密码', trigger: 'blur' },]
			}
		},
		info:[
			{
				title:"个人信息",
				account:'账号',
				companyName:'公司名称',
				status:'状态',
				icon:''
			},
			{
				title:"企业信息",
				account:'邮箱',
				companyName:'公司名称',
				status:'状态'
			}
		],
		mine:[
			{
				title:"我的EPD/CFP申请",
				img:require('@/assets/img/index/EPD_2x.png'),
				path: '/portal'
			},
			{
				title:"独立验证者确认",
				img:require('@/assets/img/index/LCA_2x.png'),
				path: '/company'
			}
		],
		agreement:[
			{
				title:"用户注册协议",
				img:require('@/assets/img/index/yhxy.png'),
				path: '/protocol'
			},
			{
				title:"隐私政策",
				img:require('@/assets/img/index/yszc.png'),
				path: '/protocol'
			},
		],
		mine_title:'我的',
		agree_title:'协议',
		message:{
			title:'消息通知',
			read:'已读',
			unread:'未读',
			info_title:'消息详情'
		},
		task:{
			title:'我的任务'
		},
		logout:{
			title:'我的报告',
			account:'账号：',
			tips:'温馨小提示：',
			content_1:'1、账户注销后数据不可恢复。',
			content_2:'2、不可以查看企业相关信息。',
			content_3:'3、如果想查看企业信息，可以再次注册完成企业认证后可查看企业相关信息。',
			concel:'取 消',
			confirm:'确认注销'
		}
}

export default user